import { render, staticRenderFns } from "./ReceiveForm.vue?vue&type=template&id=7778f1ba&scoped=true"
import script from "./ReceiveForm.vue?vue&type=script&lang=js"
export * from "./ReceiveForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiveForm.vue?vue&type=style&index=0&id=7778f1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7778f1ba",
  null
  
)

export default component.exports